export default "__VITE_ASSET__Bye4Cw38__"